import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loading from './components/Loading';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import AracIciYalitim from './pages/AracIciYalitim';
import DoubleDeck from './pages/DoubleDeck';
import YedekParca from './pages/YedekParca';
import BlogList from './pages/blog/BlogList';
import FrigoDorseIsiYalitimi from './pages/blog/FrigoDorseIsiYalitimi';
import DoubleDeckDorseKapasite from './pages/blog/DoubleDeckDorseKapasite';
import FrigoDorseKasaTamiri from './pages/blog/FrigoDorseKasaTamiri';
import TirDorseYedekParca from './pages/blog/TirDorseYedekParca';
import MersinFrigoDorseServisi from './pages/blog/MersinFrigoDorseServisi';

import FrigoDorseIsiYalitimiV1 from './pages/blog/FrigoDorseIsiYalitimiV1';
import FrigoDorseIsiYalitimiV2 from './pages/blog/FrigoDorseIsiYalitimiV2';
import FrigoDorseIsiYalitimiV3 from './pages/blog/FrigoDorseIsiYalitimiV3';
import FrigoDorseIsiYalitimiV4 from './pages/blog/FrigoDorseIsiYalitimiV4';
import FrigoDorseIsiYalitimiV5 from './pages/blog/FrigoDorseIsiYalitimiV5';
import FrigoDorseIsiYalitimiV6 from './pages/blog/FrigoDorseIsiYalitimiV6';
import FrigoDorseIsiYalitimiV7 from './pages/blog/FrigoDorseIsiYalitimiV7';
import FrigoDorseIsiYalitimiV8 from './pages/blog/FrigoDorseIsiYalitimiV8';
import FrigoDorseIsiYalitimiV9 from './pages/blog/FrigoDorseIsiYalitimiV9';
import FrigoDorseIsiYalitimiV10 from './pages/blog/FrigoDorseIsiYalitimiV10';
import DoubleDeckDorseKapasiteV1 from './pages/blog/DoubleDeckDorseKapasiteV1';
import DoubleDeckDorseKapasiteV2 from './pages/blog/DoubleDeckDorseKapasiteV2';
import DoubleDeckDorseKapasiteV3 from './pages/blog/DoubleDeckDorseKapasiteV3';
import DoubleDeckDorseKapasiteV4 from './pages/blog/DoubleDeckDorseKapasiteV4';
import DoubleDeckDorseKapasiteV5 from './pages/blog/DoubleDeckDorseKapasiteV5';
import DoubleDeckDorseKapasiteV6 from './pages/blog/DoubleDeckDorseKapasiteV6';
import DoubleDeckDorseKapasiteV7 from './pages/blog/DoubleDeckDorseKapasiteV7';
import DoubleDeckDorseKapasiteV8 from './pages/blog/DoubleDeckDorseKapasiteV8';
import DoubleDeckDorseKapasiteV9 from './pages/blog/DoubleDeckDorseKapasiteV9';
import DoubleDeckDorseKapasiteV10 from './pages/blog/DoubleDeckDorseKapasiteV10';
import FrigoDorseKasaTamiriV1 from './pages/blog/FrigoDorseKasaTamiriV1';
import FrigoDorseKasaTamiriV2 from './pages/blog/FrigoDorseKasaTamiriV2';
import FrigoDorseKasaTamiriV3 from './pages/blog/FrigoDorseKasaTamiriV3';
import FrigoDorseKasaTamiriV4 from './pages/blog/FrigoDorseKasaTamiriV4';
import FrigoDorseKasaTamiriV5 from './pages/blog/FrigoDorseKasaTamiriV5';
import FrigoDorseKasaTamiriV6 from './pages/blog/FrigoDorseKasaTamiriV6';
import FrigoDorseKasaTamiriV7 from './pages/blog/FrigoDorseKasaTamiriV7';
import FrigoDorseKasaTamiriV8 from './pages/blog/FrigoDorseKasaTamiriV8';
import FrigoDorseKasaTamiriV9 from './pages/blog/FrigoDorseKasaTamiriV9';
import FrigoDorseKasaTamiriV10 from './pages/blog/FrigoDorseKasaTamiriV10';
import TirDorseYedekParcaV1 from './pages/blog/TirDorseYedekParcaV1';
import TirDorseYedekParcaV2 from './pages/blog/TirDorseYedekParcaV2';
import TirDorseYedekParcaV3 from './pages/blog/TirDorseYedekParcaV3';
import TirDorseYedekParcaV4 from './pages/blog/TirDorseYedekParcaV4';
import TirDorseYedekParcaV5 from './pages/blog/TirDorseYedekParcaV5';
import TirDorseYedekParcaV6 from './pages/blog/TirDorseYedekParcaV6';
import TirDorseYedekParcaV7 from './pages/blog/TirDorseYedekParcaV7';
import TirDorseYedekParcaV8 from './pages/blog/TirDorseYedekParcaV8';
import TirDorseYedekParcaV9 from './pages/blog/TirDorseYedekParcaV9';
import TirDorseYedekParcaV10 from './pages/blog/TirDorseYedekParcaV10';
import MersinFrigoDorseServisiV1 from './pages/blog/MersinFrigoDorseServisiV1';
import MersinFrigoDorseServisiV2 from './pages/blog/MersinFrigoDorseServisiV2';
import MersinFrigoDorseServisiV3 from './pages/blog/MersinFrigoDorseServisiV3';
import MersinFrigoDorseServisiV4 from './pages/blog/MersinFrigoDorseServisiV4';
import MersinFrigoDorseServisiV5 from './pages/blog/MersinFrigoDorseServisiV5';
import MersinFrigoDorseServisiV6 from './pages/blog/MersinFrigoDorseServisiV6';
import MersinFrigoDorseServisiV7 from './pages/blog/MersinFrigoDorseServisiV7';
import MersinFrigoDorseServisiV8 from './pages/blog/MersinFrigoDorseServisiV8';
import MersinFrigoDorseServisiV9 from './pages/blog/MersinFrigoDorseServisiV9';
import MersinFrigoDorseServisiV10 from './pages/blog/MersinFrigoDorseServisiV10';

// MUI Tema oluşturma - Modern ve Profesyonel
const theme = createTheme({
  palette: {
    primary: {
      main: '#1e3a8a', // Koyu mavi
      light: '#3b82f6',
      dark: '#1e40af',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#dc2626', // Kırmızı
      light: '#ef4444',
      dark: '#b91c1c',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#1e293b',
      secondary: '#64748b',
    },
    grey: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 800,
      fontSize: '3.5rem',
      lineHeight: 1.1,
      '@media (max-width:600px)': {
        fontSize: '2.5rem',
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.2,
      '@media (max-width:600px)': {
        fontSize: '2rem',
      },
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.3,
      '@media (max-width:600px)': {
        fontSize: '1.75rem',
      },
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
      '@media (max-width:600px)': {
        fontSize: '1.25rem',
      },
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.5,
      '@media (max-width:600px)': {
        fontSize: '1.125rem',
      },
    },
    h6: {
      fontWeight: 500,
      fontSize: '1.125rem',
      lineHeight: 1.5,
      '@media (max-width:600px)': {
        fontSize: '1rem',
      },
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
          fontSize: '0.95rem',
          padding: '12px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Loading message="Kale Treyler yükleniyor..." />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/hizmetlerimiz" element={<Navigate to="/hizmetler" replace />} />
          <Route path="/hizmetler" element={<Services />} />
          <Route path="/hizmetler/arac-ici-yalitim" element={<AracIciYalitim />} />
          <Route path="/hizmetler/double-deck" element={<DoubleDeck />} />
          <Route path="/hizmetler/yedek-parca" element={<YedekParca />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi" element={<FrigoDorseIsiYalitimi />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi" element={<DoubleDeckDorseKapasite />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin" element={<FrigoDorseKasaTamiri />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi" element={<TirDorseYedekParca />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi" element={<MersinFrigoDorseServisi />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-1" element={<FrigoDorseIsiYalitimiV1 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-2" element={<FrigoDorseIsiYalitimiV2 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-3" element={<FrigoDorseIsiYalitimiV3 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-4" element={<FrigoDorseIsiYalitimiV4 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-5" element={<FrigoDorseIsiYalitimiV5 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-6" element={<FrigoDorseIsiYalitimiV6 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-7" element={<FrigoDorseIsiYalitimiV7 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-8" element={<FrigoDorseIsiYalitimiV8 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-9" element={<FrigoDorseIsiYalitimiV9 />} />
          <Route path="/blog/frigo-dorse-isi-yalitimi-10" element={<FrigoDorseIsiYalitimiV10 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-1" element={<DoubleDeckDorseKapasiteV1 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-2" element={<DoubleDeckDorseKapasiteV2 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-3" element={<DoubleDeckDorseKapasiteV3 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-4" element={<DoubleDeckDorseKapasiteV4 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-5" element={<DoubleDeckDorseKapasiteV5 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-6" element={<DoubleDeckDorseKapasiteV6 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-7" element={<DoubleDeckDorseKapasiteV7 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-8" element={<DoubleDeckDorseKapasiteV8 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-9" element={<DoubleDeckDorseKapasiteV9 />} />
          <Route path="/blog/double-deck-dorse-tasima-kapasitesi-10" element={<DoubleDeckDorseKapasiteV10 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-1" element={<FrigoDorseKasaTamiriV1 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-2" element={<FrigoDorseKasaTamiriV2 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-3" element={<FrigoDorseKasaTamiriV3 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-4" element={<FrigoDorseKasaTamiriV4 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-5" element={<FrigoDorseKasaTamiriV5 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-6" element={<FrigoDorseKasaTamiriV6 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-7" element={<FrigoDorseKasaTamiriV7 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-8" element={<FrigoDorseKasaTamiriV8 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-9" element={<FrigoDorseKasaTamiriV9 />} />
          <Route path="/blog/frigo-dorse-kasa-tamiri-mersin-10" element={<FrigoDorseKasaTamiriV10 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-1" element={<TirDorseYedekParcaV1 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-2" element={<TirDorseYedekParcaV2 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-3" element={<TirDorseYedekParcaV3 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-4" element={<TirDorseYedekParcaV4 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-5" element={<TirDorseYedekParcaV5 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-6" element={<TirDorseYedekParcaV6 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-7" element={<TirDorseYedekParcaV7 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-8" element={<TirDorseYedekParcaV8 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-9" element={<TirDorseYedekParcaV9 />} />
          <Route path="/blog/tir-dorse-yedek-parca-secimi-10" element={<TirDorseYedekParcaV10 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-1" element={<MersinFrigoDorseServisiV1 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-2" element={<MersinFrigoDorseServisiV2 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-3" element={<MersinFrigoDorseServisiV3 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-4" element={<MersinFrigoDorseServisiV4 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-5" element={<MersinFrigoDorseServisiV5 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-6" element={<MersinFrigoDorseServisiV6 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-7" element={<MersinFrigoDorseServisiV7 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-8" element={<MersinFrigoDorseServisiV8 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-9" element={<MersinFrigoDorseServisiV9 />} />
          <Route path="/blog/mersin-frigo-dorse-servisi-rehberi-10" element={<MersinFrigoDorseServisiV10 />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App; 